import { useMemo } from "react";

import ProductEventEmitter from "./ProductEventEmitter";
import { envLocker } from "../../reducers/environments";

export default function useProductEventEmitter(): ProductEventEmitter {
  const fp = window.freshpaint;

  return useMemo(() => {
    return new ProductEventEmitter(fp, envLocker);
  }, [fp]);
}
